import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import UtmifyTable from "../../../components/apps/utmify/UtmifyTable";
import { useNavigate } from "react-router";

export default function Utmify() {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(`/apps`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Utmify"
                description="Utmify"
            />
            <PageBreadcrumb
                pageTitle="Utmify"
                showBackButton={true}
                onBack={handleGoBack}
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">
                <div className="col-span-12 space-y-6">
                    <UtmifyTable />
                </div>
            </div>
        </>
    );
}